import { UnifiedGraftModelType } from '@graftcode/protocol'

export const isGlobalMethodType = (type: string | number): boolean => {
  const typeString = String(type)
  const typeNumber = typeof type === 'number' ? type : undefined

  return (
    typeString === 'GLOBAL_METHOD' ||
    typeString === 'OVERLOADED_GLOBAL_METHOD' ||
    typeNumber === UnifiedGraftModelType.GLOBAL_METHOD ||
    typeNumber === UnifiedGraftModelType.OVERLOADED_GLOBAL_METHOD
  )
}
